import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div>
      <section className="bg-gradient-to-br from-primary-600 to-primary-800 text-white">
        <div className="container-custom py-20 lg:py-32">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Fast Access to China's Top-Tier Medical Care
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-primary-100">
              Skip the wait. Get world-class healthcare with visa-free entry.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <Link
                to="/services"
                className="btn-primary bg-white text-primary-600 hover:bg-gray-100"
              >
                Start Your Journey
              </Link>
              <Link
                to="/hospitals"
                className="inline-flex items-center justify-center px-6 py-3 border border-white text-base font-medium rounded-md text-white bg-transparent hover:bg-white/10 transition-colors"
              >
                Browse Hospitals
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="text-4xl font-bold mb-2">Visa</div>
                <div className="text-sm text-primary-100">Free Entry</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="text-4xl font-bold mb-2">50+</div>
                <div className="text-sm text-primary-100">Top-Tier Hospitals</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="text-4xl font-bold mb-2">90%</div>
                <div className="text-sm text-primary-100">Cost Savings vs Home</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="container-custom">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Why Choose ChinaHospital?
            </h2>
            <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
              We connect international patients with China's best hospitals, making medical tourism simple and affordable.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="card p-6">
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-2">Fast Access</h3>
                <p className="text-gray-600">
                  Get appointments within days, not months. Many hospitals offer same-day or next-day consultations for urgent cases.
                </p>
              </div>

              <div className="card p-6">
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-2">Cost-Effective</h3>
                <p className="text-gray-600">
                  Premium healthcare at a fraction of the cost. Save 70-90% compared to US/European prices for the same procedures.
                </p>
              </div>

              <div className="card p-6">
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-2">Hassle-Free</h3>
                <p className="text-gray-600">
                  We handle the language barrier, appointment booking, and logistics. You focus on your health.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-custom">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              Our Services
            </h2>
            <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
              Choose the level of support that fits your needs.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="card p-6 text-center">
                <div className="text-3xl mb-3">📋</div>
                <h3 className="text-xl font-semibold mb-2">Medical Guide</h3>
                <div className="text-2xl font-bold text-primary-600 mb-1">$9.99</div>
                <div className="text-xs text-gray-500 mb-4">One-time payment</div>
                <p className="text-gray-600 mb-4 text-sm">
                  Bilingual medical guide with hospital, department, and doctor information plus registration assistance.
                </p>
                <Link to="/services" className="btn-primary w-full text-sm">
                  Get Guide
                </Link>
              </div>

              <div className="card p-6 text-center border-2 border-blue-500 relative">
                <div className="absolute top-2 left-1/2 transform -translate-x-1/2">
                  <span className="bg-blue-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
                    New!
                  </span>
                </div>
                <div className="text-3xl mb-3">📹</div>
                <h3 className="text-xl font-semibold mb-2">Online Meeting</h3>
                <div className="text-2xl font-bold text-blue-600 mb-1">$19.9</div>
                <div className="text-xs text-gray-500 mb-4">30-minute session</div>
                <p className="text-gray-600 mb-4 text-sm">
                  Get instant answers to your questions through a video call with our experts.
                </p>
                <Link to="/services" className="btn-primary w-full text-sm">
                  Book Meeting
                </Link>
              </div>

              <div className="card p-6 text-center border-primary-500 border-2 relative">
                <div className="absolute top-2 left-1/2 transform -translate-x-1/2">
                  <span className="bg-primary-600 text-white text-sm font-semibold px-4 py-1 rounded-full">
                    Most Popular
                  </span>
                </div>
                <div className="text-3xl mb-4">💬</div>
                <h3 className="text-xl font-semibold mb-2">Consultation</h3>
                <div className="text-2xl font-bold text-primary-600 mb-1">$99</div>
                <div className="text-sm text-gray-500 mb-4">One-time payment</div>
                <p className="text-gray-600 mb-4">
                  Get personalized advice on which hospitals and doctors best fit your condition.
                </p>
                <Link to="/services" className="btn-primary w-full text-sm">
                  Get Consultation
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-primary-50">
        <div className="container-custom">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              How It Works
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">1</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Explore</h3>
                <p className="text-gray-600 text-sm">
                  Browse our hospital directory and learn about visa-free entry policies.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">2</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Choose</h3>
                <p className="text-gray-600 text-sm">
                  Select your service: Medical Guide ($9.99), Online Meeting ($19.9), or Consultation ($99).
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">3</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Travel</h3>
                <p className="text-gray-600 text-sm">
                  Arrive in China with your visa and head to your scheduled appointment.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-white">4</span>
                </div>
                <h3 className="text-lg font-semibold mb-2">Recover</h3>
                <p className="text-gray-600 text-sm">
                  Receive world-class medical care and continue your journey or return home.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Ready to Get Started?
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              Join thousands of international patients who have accessed quality healthcare in China through our platform.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/hospitals"
                className="btn-primary"
              >
                Browse Hospitals
              </Link>
              <Link
                to="/services"
                className="btn-secondary"
              >
                View Services & Pricing
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
